import { Button } from "components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover";
import { ChevronDown, ChevronUp, Ellipsis, ZoomInIcon, ZoomOutIcon } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Service } from "utils/services";
import ImageUrl from "../image-url/ImageUrl";
import { usePostOptions } from "store/popover/usePostOptionStore";
import { DropdownMenuItem, DropdownMenuSeparator } from "components/ui/dropdown-menu";
import PostOption from "../post-option/PostOption";
import { AppLog } from "services";
import NewFeedDailogBlock from "../new-feed-post/new-feed-components/new-feed-dialogs/NewFeedDialogBlock";
import NewFeedDailogDeletePost from "../new-feed-post/new-feed-components/new-feed-dialogs/NewFeedDialogDeletePost";
import NewFeedDialogReportPost from "../new-feed-post/new-feed-components/new-feed-dialogs/NewFeedDialogReportPost";

export default function PhotoPostContent({
  post,
  isAlbum,
  scaleAlbum,
}: // onOpenPostOption,
{
  post: any;
  isAlbum?: boolean;
  scaleAlbum?: number;
  // onOpenPostOption: (e: React.MouseEvent<HTMLButtonElement>, post: any) => void;
}) {
  const [isPortrait, setIsPortrait] = useState(false);
  const [imageSrc, setImageSrc] = useState<string>();
  const [alt, setAlt] = useState<string>();
  const [scale, setScale] = useState(1);
  const maxZoom = 1.8;
  const minZoom = 1;

  const [postOption, setPostOption] = useState<{
    isOpen: boolean;
    buttonRef: HTMLButtonElement | null;
    post: any;
  }>({
    isOpen: false,
    buttonRef: null,
    post: null,
  });

  // Popover Option
  const onOpenPostOption = (e: React.MouseEvent<HTMLButtonElement>, post: any) => {
    setPostOption({
      isOpen: true,
      buttonRef: e.currentTarget,
      post: post,
    });
  };

  const onClosePostOption = () => {
    setPostOption({
      isOpen: false,
      buttonRef: null,
      post: null,
    });
  };

  const handleZoomIn = (event: React.MouseEvent<SVGElement>) => {
    event.preventDefault();
    if (scale < maxZoom) {
      setScale((prev) => Math.min(prev + 0.1, maxZoom));
    }
  };

  const handleZoomOut = (event: React.MouseEvent<SVGElement>) => {
    event.preventDefault();
    if (scale > minZoom) {
      setScale((prev) => Math.max(prev - 0.1, minZoom));
    }
  };

  useEffect(() => {
    setImageSrc(post?.attachment_media_image_file_src ?? "null");
    setAlt(post?.attachment_thumbnail_image_file_src ?? "null");
    let width = post?.attachment_media_width ?? 16;
    let height = post?.attachment_media_height ?? 9;

    if (height > width) {
      setIsPortrait(true);
    } else {
      setIsPortrait(false);
    }
    if (imageSrc != "" && imageSrc != "null") {
      if (Service.applicationMode.isDebug()) {
        setImageSrc(post?.attachment_media_image_file_src.replace("https", "http"));
      }
    }
    if (alt != "" && alt != "null") {
      if (Service.applicationMode.isDebug()) {
        setAlt(post?.attachment_thumbnail_image_file_src.replace("https", "http"));
      }
    }
  }, [post]);

  const { options, initializePage } = usePostOptions();

  // ------------------State and function Dailog---------------------
  const [dialogBlock, setDialogBlock] = useState({
    isOpen: false,
    post: null,
    label: null,
  });
  const onOpenDialogBlock = (post: any, label: any) => {
    try {
      setDialogBlock({
        isOpen: true,
        post: post,
        label: label,
      });
    } catch (err) {
      AppLog.show({ message: `catch onPosreactionClick ${err}` });
    }
  };
  const [dialogDeletePost, setDialogDeletePost] = useState({
    isOpen: false,
    post: null,
    label: null,
  });

  const onOpenDialogDeletePost = (post: any, label: any) => {
    try {
      setDialogDeletePost({
        isOpen: true,
        post: post,
        label: label,
      });
    } catch (err) {
      AppLog.show({ message: `catch onPosreactionClick ${err}` });
    }
  };
  const [dialogReportPost, setDialogReportPost] = useState({
    isOpen: false,
    post: null,
    label: null,
  });
  const onOpenDialogReportPost = (post: any, label: any) => {
    try {
      setDialogReportPost({
        isOpen: true,
        post: post,
        label: label,
      });
    } catch (err) {
      AppLog.show({ message: `catch onPosreactionClick ${err}` });
    }
  };

  return (
    <>
      <div className="flex justify-center items-center h-[60vh] lg:h-screen">
        <img
          src={imageSrc}
          alt={alt}
          style={{
            transform: `scale(${scaleAlbum ?? scale}) `,
          }}
          className={`${isPortrait ? ` lg:max-w-[${post?.attachment_media_width}px] object-cover lg:h-screen h-[60vh]` : "  object-cover rounded-md lg:h-[60vh] "}`}
        />
      </div>

      {isAlbum ? (
        <></>
      ) : (
        <>
          <div className="absolute max-sm:top-3 max-sm:right-3 top-5 right-8 flex space-x-2  z-50 select-none">
            <ZoomInIcon
              onClick={handleZoomIn}
              className={`w-8 max-sm:w-6 max-sm:h-6 h-8 bg-gray-600 text-white opacity-70 rounded-full p-1 transition-opacity duration-200 cursor-pointer ${
                scale >= maxZoom ? "opacity-50 cursor-not-allowed" : "hover:opacity-100"
              }`}
            />
            <ZoomOutIcon
              onClick={handleZoomOut}
              className={`w-8 h-8 max-sm:w-6 max-sm:h-6 bg-gray-600 text-white opacity-70 rounded-full p-1 transition-opacity duration-200 cursor-pointer ${
                scale <= minZoom ? "opacity-50 cursor-not-allowed" : "hover:opacity-100 cursor-pointer"
              }`}
            />
            {/* <Ellipsis
              onClick={(e: any) => onOpenPostOption(e, post)}
              className="w-8 h-8 max-sm:w-6 cursor-pointer max-sm:h-6 bg-gray-600 text-white opacity-70 rounded-full p-1 transition-opacity duration-200"
            /> */}
            {/* </Button> */}
          </div>
          {/* {dialogBlock.isOpen && (
            <NewFeedDailogBlock
              post={dialogBlock?.post}
              label={dialogBlock?.label}
              // onSuccess={(post) => onClickedShare(post)}
              isDialogOpen={dialogBlock.isOpen}
              setIsDialogOpen={(isOpen) =>
                setDialogBlock({ ...dialogBlock, isOpen })
              }
            />
          )}

          {dialogDeletePost.isOpen && (
            <NewFeedDailogDeletePost
              post={dialogDeletePost?.post}
              label={dialogDeletePost?.label}
              // onSuccess={(post) => onClickedShare(post)}
              isDialogOpen={dialogDeletePost.isOpen}
              setIsDialogOpen={(isOpen) =>
                setDialogDeletePost({ ...dialogDeletePost, isOpen })
              }
            />
          )}

          {dialogReportPost.isOpen && (
            <NewFeedDialogReportPost
              post={dialogReportPost?.post}
              label={dialogReportPost?.label}
              // onSuccess={(post) => onClickedShare(post)}
              isDialogOpen={dialogReportPost.isOpen}
              setIsDialogOpen={(isOpen) =>
                setDialogReportPost({ ...dialogReportPost, isOpen })
              }
            />
          )}

          {postOption.isOpen && (
            <PostOption
              isOpen={postOption.isOpen}
              onOpenChange={(_) => onClosePostOption()}
              post={postOption.post}
              buttonRef={postOption.buttonRef}
              onClickShare={({ post, label }) => {
                console.log("post", post);
                console.log("label", label);
                if (label === "Share Post") {
                  // onOpenDialogShare("");
                } else if (label === "Block User") {
                  onOpenDialogBlock(post, label);
                } else if (label === "Boring User") {
                  onOpenDialogBlock(post, label);
                } else if (label === "Delete Post") {
                  onOpenDialogDeletePost(post, label);
                } else if (label === "Report Post") {
                  onOpenDialogReportPost(post, label);
                }
              }}
            />
          )} */}
        </>
      )}
    </>
  );
}
